import React from 'react';
import { Route } from 'react-router-dom';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { BreadcrumbsItem } from '@app/layouts/layout';
import RequiredAuth from '@app/routes/required-auth.route';
import { LastProjectOutlet, LastProjectRecordsPage, SingleLastRecordPage } from '@app/pages';

export const chatLastRecordRoute = (
  <Route
    path={navigationRoutes.chatProjectRecords}
    element={
      <RequiredAuth>
        <LastProjectOutlet currentTemplate="chat" />
      </RequiredAuth>
    }
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.chatProjectRecords} crumb="project_records" />
      ),
    }}
  >
    <Route index element={<LastProjectRecordsPage currentTemplate="chat" />} />
    <Route path=":recordProjectId">
      <Route path=":recordId" element={<SingleLastRecordPage currentTemplate="chat" />} />
    </Route>
  </Route>
);
